<kf-confirm>
  <kf-modal modal="{ state.modal }">
    <div class="confirm-container">
      <div class="confirm-message">{ state.message }</div>
      <div class="confirm-button-group text-right">
        <button each="{ key in state.ext }" key="{ key[0] }" class="{ 'btn ' + (key[2] ? 'btn-blue btn-ok' : 'btn-flat btn-cancel') }" onclick="{ () => onExt(key[0]) }">{ key[1] }</button>
        <button if="{ !state.withTrue }" class="btn btn-blue btn-ok" onclick="{ onOK }" >OK</button>
        <button if="{ !state.withFalse }" class="btn btn-flat btn-cancel" onclick="{ onCancel }">キャンセル</button>
      </div>
    </div>
  </kf-modal>
  <script>
    import { KfModal } from '../kf-modal';
    import { model, CONFIRM_OK, CONFIRM_CANCEL, CONFIRM_OPEN, CONFIRM_CLOSE, CONFIRM_EXT, CONFIRM_CLOSE_WITH_OK } from './observable';
    export default {
      components: {
        KfModal,
      },
      state: {
        message: '',
        ext: [], // [string, any][]
        withTrue: false, 
        withFalse: false, 
        modal: {
          show: false,
          size: 450,
        },
      },
      onMounted() {
        document.addEventListener('keyup', this.onKeyUp, { passive: true });
        model.on(CONFIRM_OPEN, this.confirmOpen);
        model.on(CONFIRM_CLOSE, this.confirmClose);
        model.on(CONFIRM_CLOSE_WITH_OK, this.onOK);
      },
      onUnmounted() {
        document.removeEventListener('keyup', this.onKeyUp);
        model.off(CONFIRM_OPEN, this.confirmOpen);
        model.off(CONFIRM_CLOSE, this.confirmClose);
        model.off(CONFIRM_CLOSE_WITH_OK, this.onOK);
      },
      confirmOpen(message, ...ext) {
        ext = ext ?? [];
        this.update({
          message: message,
          ext: ext,
          withTrue: ext.filter(x => x[0] === true).length > 0, 
          withFalse: ext.filter(x => x[0] === false).length > 0,
          modal: {
            ...this.state.modal,
            show: true,
          },
        });
        const btnOk = this.$('.btn-ok');
        if (btnOk != null) {
          // エンターキーで confirm が開いたら、同じフレームでOKボタンも押されないよう次のフレームを待つ
          requestAnimationFrame(() => btnOk.focus());
        }
      },
      confirmClose() {
        model.trigger(CONFIRM_CANCEL);
        this.closeModal();
      },
      closeModal() {
        this.update({
          message: '',
          modal: {
            ...this.state.modal,
            show: false,
          },
        });
      },
      onKeyUp(e) {
        const key = e.key || e.code;
        if (key === 'Escape') {
          model.trigger(CONFIRM_CANCEL);
          this.closeModal();
        }
      },
      onOK() {
        model.trigger(CONFIRM_OK);
        this.closeModal();
      },
      onCancel() {
        model.trigger(CONFIRM_CANCEL);
        this.closeModal();
      },
      onExt(data) {
        model.trigger(CONFIRM_EXT, data);
        this.closeModal();
      },
    };
  </script>
  <style>
    :host kf-modal .modal-container {
      z-index: 20000;
    }

    .confirm-container {
      padding: 24px 16px 16px 16px;
    }

    .confirm-message {
      min-height: 40px;
      white-space: pre-wrap;
    }

    .confirm-button-group {
      margin-top: 12px;
    }

    .btn {
      min-width: 90px;
      padding: 0 12px;
      margin: 0;
    }
    
    .btn + .btn {
      margin-left: 8px;
    }

    .btn-cancel {
      border: 1px solid rgb(220, 220, 220);
    }
  </style>
</kf-confirm>